import type { Breakpoints } from '@oneaudi/unified-web-common';
import type { AssetTypeVideo } from '../../types';
import { parseAssetValue } from './parseAssetValue';

export type Video = {
  alt?: string;
  aspectRatio: string;
  poster?: string;
  src: string;
  caption?: string;
  isFullWidth?: boolean;
  audioDescription?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  nativeControls?: boolean;
};

export type VideoPlayerConfig = {
  videos: Partial<Breakpoints<Video>>;
  playsInline: boolean;
  cover?: boolean;
  isFormatable?: boolean;
};

export function getVideoPlayerConfig(video: AssetTypeVideo): VideoPlayerConfig {
  const parsedPoster = parseAssetValue(video.poster?.assetValue).src;
  const parsedVideo = parseAssetValue(video.src.assetValue);
  const parsedCaptions = parseAssetValue(video.captions?.assetValue);
  const parsedAD = parseAssetValue(video.audioDescription?.assetValue);

  // separately provided poster image url overrides the VMS thumbnail image used as poster image
  const posterSrc = parsedPoster || parsedVideo.posterSrc;

  return {
    cover: video.preserveVideoWidth === true ? false : true,
    playsInline: true,
    videos: {
      xs: {
        alt: video.alt,
        poster: posterSrc,
        caption: parsedCaptions.src,
        isFullWidth: false,
        nativeControls: true,
        audioDescription: parsedAD.src,
        aspectRatio: '3/4',
        autoPlay: video.autoPlay,
        loop: video.loop,
        muted: video.muted,
        src: parsedVideo.src,
      },
    },
  };
}
